import { gql } from '@apollo/client';

export const SEARCH_TERM = gql`
  query SearchTerm {
    projectSearch @client {
      term
    }
  }
`;
